<template>
  <tr v-if="item">
    <td>
      <input type="hidden" name="attr_id[]" readonly :value="(attr.attr?attr.attr._id:'')">
      <v-select append-to-body @search="getAttributeForSelect" placeholder="انتخاب کنید"  v-model="attr.attr"  dir="rtl" :options="attr.options"  label="title" ></v-select>
    </td>
    <td>
      <input type="hidden" readonly hidden v-for="(item,index) in attr.attr_items" :value="(item._id?item._id:item)" :name="'item_id'+(attr.attr?attr.attr._id:'')+'[]'">
      <v-select :deselectFromDropdown="true" :closeOnSelect="false" append-to-body v-model="attr.attr_items" :reduce="(option)=>option._id" label="title" multiple :options="attr.item_options" dir="rtl" placeholder="انتخاب مقادیر"></v-select>
    </td>
    <td>
      <button @click="$emit('delete')" class="btn btn-danger" type="button">
        <i class="far fa-trash-can"></i>
      </button>
    </td>
  </tr>
</template>

<script>
import CustomInput from "@/components/CustomInput";
import vSelect from 'vue-select'
import {AppApi} from "@/api/AppApi";
export default {
  name: "PCatAttrItem",
  components: {CustomInput,vSelect},
  props : ['item','index'],
  mounted() {
    this.attr = JSON.parse(JSON.stringify(this.item));
    const items = this.attr.attr_items;
    if (items && items.length)
    {
      for (let i = 0; i < items.length; i++)
      {
        this.attr_item_ids.push(items[i]._id);
      }
    }
  },
  data(){
    return{
      attr : {},
      first_init : true,
      attr_item_ids : [],
    }
  },
  methods : {
    async getAttributeForSelect(search,loading)
    {
      loading(true);
      if (search && search.length)
      {
        const data = await AppApi.getProductAttributeForSelectAjax(search);
        if (data.ok)
        {
          this.attr.options =  data.attributes;
        }
      }
      loading(false);
    },
    async changeAttr()
    {
      const attr = this.attr.attr;
      if (attr)
      {
        const id = attr._id;
        const result = await AppApi.getAttributeValuesForSelect(id);
        if (result)
        {
          this.attr.item_options = result.items;
        }
        else
        {
          this.attr.attr_items = [];
          this.attr.item_options = [];
        }
      }
      else
      {
        this.attr.attr_items = [];
        this.attr.item_options = [];
      }
    }
  },
  watch: {
    'attr.attr': {
      async handler(newAttr,oldAttr) {
        if (newAttr && newAttr !== oldAttr)
        {
          if (!this.first_init)
            this.attr.attr_items = [];
          else
            this.first_init = false;
          await this.changeAttr();
        }
      },
      deep: true
    },
  }
}
</script>

<style scoped>

</style>